import EventBus from '@/events/EventBus';
import Events from '@/events/Events';
import {shuffleArray} from '@/helper/ArrayHelper';
import {saveNewSearch} from '@/helper/LastSearchesHelper';
import {
  createObjectFromQuery,
  createObjectFromUrlSearchParams,
  createUrlSearchParamsFromObject,
  createObjectFromQueryString,
} from '@/helper/QueryHelper';
import TypesenseMixin from '@/mixins/TypesenseMixin';

export default {
  mixins: [TypesenseMixin],
  data() {
    return {
      newSearchArray: [],
      loading: true,
      mergedJobPostings: [],
      topJobPositions: [],
      instantTeaserPositions: [],
      instantTeaserAddition: 1,
      page: 1,
      countPages: 0,
      itemsPerPage: 16,
      jobPostingsCount: 0,
      filterParams: '',
      facets: undefined,
      orderBy: {},
      orderByDefault: {key: 'order_number', direction: 'desc'},
      orderByItems: [
        {
          value: {key: 'order_number', direction: 'desc'},
          text: this.$t('orderBy.order_number.desc'),
        },
        {
          value: {key: 'order_number', direction: 'asc'},
          text: this.$t('orderBy.order_number.asc'),
        },
        {
          value: {key: 'date', direction: 'desc'},
          text: this.$t('orderBy.date.desc'),
        },
        {
          value: {key: 'date', direction: 'asc'},
          text: this.$t('orderBy.date.asc'),
        },
      ],
      title: '',
    };
  },
  async fetch() {
    this.parseOrderAndPageFromQuery();
    this.generateFilterParamsFromQuery();

    await this.fetchJobPostings();
    this.prepareTitle();
  },
  computed: {
    currentUrl() {
      const getParameters = new URLSearchParams(this.fullFilterParams);
      getParameters.delete('user_search');
      getParameters.set(`order[${this.orderBy.key}]`, this.orderBy.direction);
      getParameters.set('itemsPerPage', this.itemsPerPage);
      getParameters.set('page', this.page);
      return decodeURI(getParameters.toString()) + '&isPublished=1';
    },
    filterParamsObjectFromSection() {
      const filterParams = {};
      if (this.section.filterParams && this.section.filterParams.search) {
        filterParams.search = this.section.filterParams.search;
      }
      if (this.section.filterParams && this.section.filterParams.activities) {
        filterParams['activity[]'] = this.section.filterParams.activities
          .split(',')
          .map((value) => value.trim());
      }
      if (
        this.section.filterParams &&
        this.section.filterParams.latitude &&
        this.section.filterParams.longitude &&
        this.section.filterParams.distance
      ) {
        filterParams.distance = `${this.section.filterParams.latitude},${this.section.filterParams.longitude},${this.section.filterParams.distance}`;
      }
      return filterParams;
    },
    forcedFilterParams() {
      const forcedFilterParams = new URLSearchParams();
      if (this.section.filterParams && this.section.filterParams.tags) {
        this.section.filterParams.tags.split(',').forEach((value) => {
          forcedFilterParams.append('tagsOr[]', value.trim());
        });
      }
      return forcedFilterParams.toString();
    },
    fullFilterParams() {
      const glue =
        this.filterParamsWithMyFilters !== '' && this.forcedFilterParams !== ''
          ? '&'
          : '';
      return this.filterParamsWithMyFilters + glue + this.forcedFilterParams;
    },
  },
  watch: {
    '$route.query': function () {
      const pageBefore = this.page;
      const orderByBefore = this.orderBy;
      const filterParamsBefore = this.filterParams;

      this.parseOrderAndPageFromQuery();
      this.generateFilterParamsFromQuery();

      if (
        pageBefore !== this.page ||
        orderByBefore.key !== this.orderBy.key ||
        orderByBefore.direction !== this.orderBy.direction ||
        filterParamsBefore !== this.filterParams
      ) {
        this.fetchJobPostings();
      }
    },
    jobPostingsCount: function () {
      this.prepareTitle();
    },
    mergedJobPostings: function () {
      this.emitJobListingView();
    },
  },
  created() {
    if (process.client) {
      EventBus.$on('login', this.fetchJobPostings);
      EventBus.$on('logout', this.fetchJobPostings);

      EventBus.$on('applied-on-job', this.refetchJobPosting);
      EventBus.$on('favored-job', this.refetchJobPosting);
      EventBus.$on('unfavored-job', this.refetchJobPosting);
    }
  },
  destroyed() {
    if (process.client) {
      EventBus.$off('login', this.fetchJobPostings);
      // this breaks!??? WHY!????
      // EventBus.$off('logout', this.fetchJobPostings);
      // This works though
      EventBus.$off('logout');

      EventBus.$off('applied-on-job', this.refetchJobPosting);
      EventBus.$off('favored-job', this.refetchJobPosting);
      EventBus.$off('unfavored-job', this.refetchJobPosting);
    }
  },
  methods: {
    parseOrderAndPageFromQuery() {
      this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;

      const foundOrder = Object.keys(this.$route.query).find((k) =>
        k.includes('order[')
      );
      if (foundOrder) {
        const order = foundOrder.match(/^order\[(.+)\]$/)[1];
        this.orderBy = {
          key: order,
          direction: this.$route.query[foundOrder],
        };
      } else {
        this.orderBy = {...this.orderByDefault};
      }
    },
    generateFilterParamsFromQuery() {
      const filterParams = this.$route.query.user_search
        ? {}
        : {...this.filterParamsObjectFromSection};

      const queryParams = createObjectFromQuery(this.$route.query);
      for (const key in queryParams) {
        if (!Object.prototype.hasOwnProperty.call(queryParams, key)) {
          continue;
        }
        if (key === 'page' || key.includes('order[')) {
          continue;
        }
        filterParams[key] = queryParams[key];
      }
      const urlSearchParams = createUrlSearchParamsFromObject(filterParams);
      urlSearchParams.sort();
      this.filterParams = urlSearchParams.toString();
    },
    async fetchJobPostings() {
      const getParameters = new URLSearchParams();
      getParameters.set(
        'query_by',
        'job_id,name,number,activity_translated,industry_translated,company,short_description,description,location,requirement'
      );
      getParameters.set('query_by_weights', '4,4,4,4,4,4,3,1,1,1');
      getParameters.set('include_fields', 'id');

      const fullFilterParams = new URLSearchParams(this.fullFilterParams);
      const postParameters =
        this.convertFilterParamsToTypesense(fullFilterParams);
      const postParametersTopJob = new URLSearchParams();
      const postParametersInstantTeaser = new URLSearchParams(postParameters);

      postParameters.set('collection', 'job_posting');
      postParameters.set('per_page', this.itemsPerPage);
      postParameters.set('page', this.page);
      postParameters.set('max_facet_values', 100);
      postParameters.set('facet_by', 'activity,industry,employment_types');
      const orderByMapping = {
        order_number: 'order_number',
        date: 'order_date',
      };
      postParameters.set(
        'sort_by',
        `${orderByMapping[this.orderBy.key]}(missing_values: last):${
          this.orderBy.direction
        }`
      );

      postParametersTopJob.set('collection', 'job_posting_top_job');
      postParametersTopJob.set('q', '*');
      postParametersTopJob.set('per_page', '100');
      postParametersTopJob.set('page', '1');

      postParametersInstantTeaser.set(
        'collection',
        'job_posting_instant_teaser'
      );
      postParametersInstantTeaser.set('per_page', '100');
      postParametersInstantTeaser.set('page', '1');

      const searches = [
        postParameters,
        postParametersTopJob,
        postParametersInstantTeaser,
      ];

      let activityFacetIndex = 0;
      if (fullFilterParams.has('activity[]')) {
        const activityFacetParameters = new URLSearchParams(fullFilterParams);
        activityFacetParameters.delete('activity[]');
        const convertedActivityParameters = this.convertFilterParamsToTypesense(
          activityFacetParameters
        );
        convertedActivityParameters.set('collection', 'job_posting');
        convertedActivityParameters.set('per_page', '0');
        convertedActivityParameters.set('page', '1');
        convertedActivityParameters.set(
          'facet_by',
          'activity,industry,employment_types'
        );
        convertedActivityParameters.set('max_facet_values', 100);
        searches.push(convertedActivityParameters);
        activityFacetIndex = searches.length - 1;
      }

      let industryFacetIndex = 0;
      if (fullFilterParams.has('industry[]')) {
        const industriesFacetParameters = new URLSearchParams(fullFilterParams);
        industriesFacetParameters.delete('industry[]');
        const convertedIndustriesParameters =
          this.convertFilterParamsToTypesense(industriesFacetParameters);
        convertedIndustriesParameters.set('collection', 'job_posting');
        convertedIndustriesParameters.set('per_page', '0');
        convertedIndustriesParameters.set('page', '1');
        convertedIndustriesParameters.set(
          'facet_by',
          'activity,industry,employment_types'
        );
        convertedIndustriesParameters.set('max_facet_values', 100);
        searches.push(convertedIndustriesParameters);
        industryFacetIndex = searches.length - 1;
      }

      let employmentTypesFacetIndex = 0;
      if (fullFilterParams.has('employmentTypesOr[]')) {
        const employmentTypesFacetParameters = new URLSearchParams(
          fullFilterParams
        );
        employmentTypesFacetParameters.delete('employmentTypesOr[]');
        const convertedEmploymentTypesParameters =
          this.convertFilterParamsToTypesense(employmentTypesFacetParameters);
        convertedEmploymentTypesParameters.set('collection', 'job_posting');
        convertedEmploymentTypesParameters.set('per_page', '0');
        convertedEmploymentTypesParameters.set('page', '1');
        convertedEmploymentTypesParameters.set(
          'facet_by',
          'activity,industry,employment_types'
        );
        convertedEmploymentTypesParameters.set('max_facet_values', 100);
        searches.push(convertedEmploymentTypesParameters);
        employmentTypesFacetIndex = searches.length - 1;
      }

      const typesenseSearches = searches.map((search) =>
        Object.fromEntries(search)
      );

      if (process.client) {
        await this.$localforage.setItem(
          'TypesenseParams',
          typesenseSearches[0]
        );
      }

      const results = (
        await this.$store.dispatch(
          'api/jobPosting/getJobPostingsFromTypesenseMultisearch',
          {
            getParameters,
            searches: typesenseSearches,
          }
        )
      ).results;

      let error = false;
      results.forEach((result) => {
        if (result.code) error = true;
      });
      const jobPostingResponse = results[0],
        jobPostingTopJobResponse = results[1],
        jobPostingInstantTeaserResponse = results[2];

      // Shuffle and Slice Top Jobs
      jobPostingTopJobResponse.hits = shuffleArray(
        jobPostingTopJobResponse.hits
      ).slice(0, 1);

      // Shuffle and Slice Instant Teaser
      jobPostingInstantTeaserResponse.hits = shuffleArray(
        jobPostingInstantTeaserResponse.hits
      ).slice(0, 2);

      if (!error) {
        this.jobPostingsCount = jobPostingResponse.found;
        this.countPages = Math.ceil(
          jobPostingResponse.found / this.itemsPerPage
        );
        this.facets = {
          activity: results[activityFacetIndex].facet_counts[0].counts,
          industry: results[industryFacetIndex].facet_counts[1].counts,
          employment_types:
            results[employmentTypesFacetIndex].facet_counts[2].counts,
        };
      } else {
        this.jobPostingsCount = 0;
        this.countPages = 0;
      }

      let orderedJobPostings = [],
        orderedTopJobJobPosting = [],
        orderedInstantTeaserJobPostings = [];
      if (this.jobPostingsCount > 0) {
        const apiGetParameters = new URLSearchParams();
        const idsToGet = [];
        const addHitToIdArray = (item) => {
          if (idsToGet.indexOf(item.document.id) === -1)
            idsToGet.push(item.document.id);
        };
        jobPostingResponse.hits.forEach(addHitToIdArray);
        jobPostingTopJobResponse.hits.forEach(addHitToIdArray);
        jobPostingInstantTeaserResponse.hits.forEach(addHitToIdArray);
        idsToGet.forEach((id) => apiGetParameters.append('id[]', id));

        const jobPostings = (
          await this.$store.dispatch(
            'api/jobPosting/getJobPostings',
            apiGetParameters
          )
        ).data;

        const findJobPostingById = (id) => {
          let foundJobPosting;
          for (const jobPosting of jobPostings) {
            if (jobPosting && jobPosting.id === id) {
              foundJobPosting = jobPosting;
              break;
            }
          }
          return foundJobPosting;
        };

        const orderJobPostings = (hits) => {
          const orderedJobPostings = [];
          for (let i = 0; i < hits.length; i++) {
            const foundJobPosting = findJobPostingById(hits[i].document.id);
            if (foundJobPosting) orderedJobPostings[i] = foundJobPosting;
          }
          return orderedJobPostings;
        };

        orderedJobPostings = orderJobPostings(jobPostingResponse.hits);
        orderedTopJobJobPosting = orderJobPostings(
          jobPostingTopJobResponse.hits
        );
        orderedInstantTeaserJobPostings = orderJobPostings(
          jobPostingInstantTeaserResponse.hits
        );
      }

      this.mergedJobPostings = this.mergeJobPostings(
        orderedJobPostings,
        orderedTopJobJobPosting[0],
        orderedInstantTeaserJobPostings
      );
      this.loading = false;
    },
    mergeJobPostings(jobPostings, topJobPosting, instantTeaserJobPostings) {
      this.instantTeaserPositions = [];
      this.topJobPositions = [];

      const filteredJobPostings = [];

      if (topJobPosting) {
        filteredJobPostings.push(topJobPosting);
        this.topJobPositions.push(filteredJobPostings.length);
      }

      for (const jobPosting of jobPostings) {
        if (
          !this.isTopJobPosting(jobPosting, topJobPosting) &&
          !this.isInstantTeaserJobPosting(jobPosting, instantTeaserJobPostings)
        ) {
          filteredJobPostings.push(jobPosting);
        }
      }

      // short exit if no instantTeaserJobPostings
      if (instantTeaserJobPostings.length === 0) {
        return filteredJobPostings;
      }

      const numInstantTeasers =
        instantTeaserJobPostings.length + this.instantTeaserAddition;
      const cutOff = filteredJobPostings.length % numInstantTeasers;
      const jobsInterval =
        (filteredJobPostings.length - cutOff) / numInstantTeasers;

      let mergedJobs = [];
      for (let i = 0; i < numInstantTeasers; i++) {
        mergedJobs = mergedJobs.concat(
          filteredJobPostings.splice(0, jobsInterval === 0 ? 1 : jobsInterval)
        );
        this.addInstantTeaser(
          mergedJobs,
          i,
          instantTeaserJobPostings,
          topJobPosting
        );
      }
      mergedJobs = mergedJobs.concat(filteredJobPostings);
      return mergedJobs;
    },
    isTopJobPosting(jobPosting, topJobPosting) {
      return topJobPosting && jobPosting && jobPosting.id === topJobPosting.id;
    },
    isInstantTeaserJobPosting(jobPosting, instantTeaserJobPostings) {
      for (const item of instantTeaserJobPostings) {
        if (jobPosting && item.id === jobPosting.id) {
          return true;
        }
      }
      return false;
    },
    addInstantTeaser(
      mergedJobs,
      instantTeaserIndex,
      instantTeaserJobPostings,
      topJobPosting
    ) {
      if (
        instantTeaserJobPostings[instantTeaserIndex] &&
        !this.isTopJobPosting(
          instantTeaserJobPostings[instantTeaserIndex],
          topJobPosting
        )
      ) {
        mergedJobs.push(instantTeaserJobPostings[instantTeaserIndex]);
        this.instantTeaserPositions.push(mergedJobs.length);
      }
    },
    pushRouterAndFetchJobPostings() {
      this.pushRouter();
      this.fetchJobPostings();
    },
    setFilterParamsAndResetOrderAndPage(params) {
      this.page = 1;
      this.orderBy = {...this.orderByDefault};
      params.set('user_search', '1');
      this.setFilterParams(params, true);

      this.$emitWithClientData(Events.JobsSearched, {
        filterParams: createObjectFromUrlSearchParams(params),
      });
    },
    resetFilterParams() {
      this.page = 1;
      this.orderBy = {...this.orderByDefault};
      const params = createUrlSearchParamsFromObject({
        ...this.filterParamsObjectFromSection,
      });
      params.set('user_search', '1');
      this.setFilterParams(params, true);
    },
    setFilterParams(params, force) {
      params.sort();
      if (!force && params.toString() === this.filterParams) {
        return;
      }

      this.filterParams = params.toString();
      this.pushRouterAndFetchJobPostings();
    },
    async pushRouter() {
      const filterValues = createObjectFromQueryString(this.filterParams);
      if (
        filterValues.search ||
        filterValues.whereInput ||
        filterValues['activity[]'] ||
        filterValues['industry[]'] ||
        filterValues['employmentTypesOr[]']
      ) {
        const url =
          this.localePath({}) +
          `?${this.filterParams}` +
          `&order[${this.orderBy.key}]=${this.orderBy.direction}` +
          `&page=1`;
        const newSearch = {
          page: this.$route.path,
          url: url,
          what: filterValues.search || '',
          where: filterValues.whereInput || '',
          activities: filterValues['activity[]'] || [],
          branches: filterValues['industry[]'] || [],
          employmentTypesOr: filterValues['employmentTypesOr[]'] || [],
        };
        this.newSearchArray = saveNewSearch(
          newSearch,
          await this.$localforage.getItem('SavedSearches')
        );
        await this.$localforage.setItem('SavedSearches', this.newSearchArray);
      }
      this.$router.push(
        this.localePath({}) +
          `?${this.filterParams}` +
          `&order[${this.orderBy.key}]=${this.orderBy.direction}` +
          `&page=${this.page}` +
          '#pb-section-jobs-with-typesense'
      );
    },
    prepareTitle() {
      this.title =
        this.section.title &&
        this.section.title.replace(
          '%num_job_postings',
          this.jobPostingsCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        );
    },
    emitJobListingView() {
      const items = this.mergedJobPostings
        .filter((item) => item != null) // Ensure the item is not null or undefined
        .map((item, key) => {
          const position = key + 1;
          return {
            id: item.id,
            topJob: this.topJobPositions.includes(position),
            instantTeaser: this.instantTeaserPositions.includes(position),
            position,
          };
        });

      this.$emitWithClientData(Events.JobListingViewed, {
        itemsPerPage: this.itemsPerPage,
        items,
        page: this.page,
      });
    },
    refetchJobPosting(jobPostingId) {
      const jobPostingPosition = this.mergedJobPostings.findIndex(
        (item) => item.id === jobPostingId
      );
      if (jobPostingPosition > -1) {
        this.$store
          .dispatch('api/jobPosting/getJobPosting', jobPostingId)
          .then((jobPosting) => {
            this.mergedJobPostings = Array.from(this.mergedJobPostings);
            this.mergedJobPostings[jobPostingPosition] = jobPosting;
          });
      }
    },
  },
};
